import styled from '@emotion/styled';
import {
  Button,
  CardBody,
  CardFooter,
  CardHeader,
  Chip,
  ReportFilled20Px,
  StarFilled16Px,
  Typography,
  blue,
  grey,
  tokens,
} from '@galaxy-react/core';

export const PreviewCardWrapper = styled('div')({
  padding: `${tokens.spacingHorizontalM} ${tokens.spacingHorizontalL} ${tokens.spacingHorizontalL}`,
  borderRadius: tokens.borderRadiusMedium,
  // Note: Colour in Figma is rgba(249, 250, 251, 0.95) but it doesn't replicate the design as it's the same colour as the Drawer background
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  height: 'fit-content',
  transition: 'height .5s ease-in',
  flex: '0 0 360px',
  marginTop: 2,
});

export const PreviewCardHeading = styled('span')({
  fontWeight: tokens.fontWeightSemibold,
  color: blue[700],
  fontSize: tokens.fontSizeBase400,
  margin: `0 ${tokens.spacingHorizontalS}`,
  maxWidth: '100%',
});

export const PreviewDescription = styled('p')({
  margin: `${tokens.spacingHorizontalL} 0`,
});

export const ChipsWrapperStyled = styled('div')({
  display: 'flex',
  height: 'min-content',
});

export const PreviewChip = styled(Chip)({
  marginRight: tokens.spacingHorizontalS,
});

export const PreviewCardInfoWrapper = styled('div')({
  padding: tokens.spacingVerticalXS,
});

export const ViewsTypography = styled(Typography)({
  marginTop: tokens.spacingVerticalS,
  marginBottom: tokens.spacingVerticalL,
  color: grey[600],
  fontSize: tokens.fontSizeBase200,
});

export const InfoTypography = styled(Typography)({
  padding: tokens.spacingVerticalXS,
  fontSize: tokens.fontSizeBase200,
});

export const PreviewCardHeader = styled(CardHeader)({
  '&.fui-CardHeader': {
    // Aligning items in the middle will make the icons jump whwn selecting long titles
    alignItems: 'start',
  },
  '& .fui-CardHeader__action': {
    fuiCardHeaderGap: 0,
  },
});

export const PreviewCardBody = styled(CardBody)({
  '> :not(.fui-CardPreview__logo)': {
    display: 'block',
  },
});

export const PreviewCardFooter = styled(CardFooter)({
  alignItems: 'center',
  marginTop: tokens.spacingVerticalXXXL,
  '& .fui-CardFooter__action': {
    width: '100%',
  },
});

export const PreviewActionButton = styled(Button)({
  '&.fui-Button': {
    minWidth: '100%',
    height: 32,
  },
});

export { ReportFilled20Px, StarFilled16Px };
